import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-randomize',
  templateUrl: './randomize.component.html',
  styleUrls: ['./randomize.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RandomizeComponent implements OnInit, OnDestroy {
  @Input() caption : string = null;

  public data: string[] = [
    '-ątko', '-cha', '-cię', '-ec', '-eczko', '-eł', '-ik', 
    '-isko', '-om', '-or', '-ówa', '-uch', '-ula', '-unia', 
    '-unio', '-ur', '-uś', '-ysko', '-ak', '-al', '-ątko', 
    '-cio', '-eczek', '-ek', '-idło', '-ina', '-isko', '-nio', 
    '-or'
  ]

  public mode = 'rotating'; //rotating,setting,stale
  public interval;
  public openned = 3;

  constructor() { }
  
  public onRandomizeClick() {
    this._setMode('setting');
    setTimeout(() => {
      this._setMode('stale')
    }, 1000);
  }

  public onResetClick() {
    this._setMode('rotating');
  }

  public isOpenned(i) {
    return (i === this.openned);
  }

  public incOpen() {
    if (this.openned < (this.data.length - 1)) {
      this.openned = this.openned + 1
    } else {
      this.openned = 0;
    }
  }
  
  private _setMode(mode: string) {
    this.mode = mode;
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      if (this.mode === 'rotating' || this.mode === 'setting') {        
        this.incOpen();      
      }
    }, 100);
  }

}
